import { useMutation, useQueryClient } from '@tanstack/react-query';

import { CreateLinkInput, DeviceLink } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig } from '@/libraries/react-query';

export const createDeviceLink = (input: CreateLinkInput): Promise<DeviceLink> => {
  return axios.post('/device-tracker/links', input);
};

type UseCreateDeviceLinkOptions = {
  config?: MutationConfig<typeof createDeviceLink>;
};

export const useCreateDeviceLink = ({ config = {} }: UseCreateDeviceLinkOptions = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    ...config,
    mutationFn: createDeviceLink,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: ['device-tracker'] });
      config.onSuccess?.(...args);
    },
  });
};
